import React from "react";
import "./about.css";
import featuresSvg from "../../static/img/features.svg";
import OwlCarousel from "react-owl-carousel";
import "../../static/css/AboutUs.css";
import BusinessModel from "./BusinessModel";
import AboutSection from "./AboutSection";
import ContactStats from "./ContactStats";

const About = () => {
  const options = {
    fade: true,
    loop: true,
    dots: false,
    setGallerySize: true,
    wrapAround: true,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    prevNextButtons: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  };
  return (
    <>
      <section className="tk-about-hero">
      <div className="container-fluid tk-about-fluid-container">
        <div className="tk-about-content-wrapper">
          
          {/* Left/Main Content Side */}
          <div className="tk-about-text-side">
            <div className="tk-about-badge">WHO WE ARE</div>
            <h2 className="tk-about-heading">
              About Us
              <span className="tk-about-sub">What do we do?</span>
              <span className="tk-about-lead">
                Over the years a lot has changed, but our goals remain the same.
              </span>
            </h2>
            <p className="tk-about-description">
              We continue to drive trust, efficiency, and excellence across our financial services and utility ecosystem, empowering partners for long-term growth.
            </p>
          </div>

          {/* Right Floating Core Feature Box */}
          <div className="tk-about-card-side">
            <div className="tk-about-visual-card">
              <div className="visual-circle-1"></div>
              <div className="visual-circle-2"></div>
              <div className="visual-content">
                <div className="visual-icon">🚀</div>
                <h4>Our Mission</h4>
                <p>Driving reliable, secure, and seamless micro-transaction infrastructure for everyone.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

      {/* <section id="about">
        <div class="container">
          <div class="row ">
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img
                  src={require("../../static/img/about-img.png")}
                  alt="About"
                />
              </div>
            </div>

            <div class="col-lg-7 col-md-6">
              <div class="about-content">
                <h2>About Us</h2>
                <h3>Established in 2015</h3>

                <p>
                  
                  <b class="dmt-D">D</b>
                  <b class="dmt-M">M</b>
                  <b class="dmt-T">T</b> Group of Companies is a professionally managed Indian business conglomerate established in 2015, with diversified interests across fintech, digital commerce, travel services, media & marketing, accounting solutions, and social welfare initiatives. Founded with a vision to bridge the gap between technology and accessibility, the group has consistently focused on creating innovative, customer-centric, and technology-driven solutions that empower businesses, retailers, entrepreneurs, and individuals across India. Over the years, DMT Group has emerged as a trusted and rapidly growing name in the digital and financial services ecosystem, driven by its commitment to integrity, transparency, operational excellence, and long-term sustainability.
                  <br />
                  <br />
                  <p class="">
                    At the core of DMT Group’s philosophy lies the mission of empowering lives through innovation and inclusive growth. The group strongly believes that technology should not only simplify services but also create opportunities for economic development and social progress. By combining digital innovation with strong business ethics, DMT Group continues to contribute towards India’s vision of financial inclusion, digital transformation, and entrepreneurial empowerment. Its solutions are designed to cater to both urban and rural markets, ensuring accessibility, convenience, and value creation for customers and partners alike.
                  </p>
                  <br />
                  <p>
                    The group operates through its esteemed entities — DMT Empire India Private Limited, Coupon Fares India Private Limited, DMT Media and Marketing Private Limited, and Shardajeet Foundation. Each organization has been strategically established to serve distinct business verticals while collectively contributing towards the group’s broader mission of digital empowerment, innovation, and sustainable growth.
                    Through its digital platforms, DMT Group offers a comprehensive range of technology-enabled services aimed at simplifying financial and lifestyle requirements. DMT Kendra serves as the flagship fintech and assisted digital services platform, offering AEPS, Domestic Money Transfer (DMT), recharge services, utility bill payments, PAN card services, micro ATM solutions, and travel booking services. The platform focuses on empowering retailers and channel partners by enabling easy access to essential financial services across India.
                  </p>
                  <br />
                  <p>
                    Coupon Fares provides affordable travel solutions including flight bookings, hotel reservations, holiday packages, and exclusive travel deals designed to deliver convenience and value-driven experiences. Finwelco is focused on financial inclusion and digital enablement through customer-oriented fintech solutions and services. Additionally, DMT Media and Marketing Private Limited strengthens the group’s capabilities in branding, digital promotions, advertising, and strategic marketing, helping businesses build impactful visibility in an evolving digital landscape.
                  </p>
                  <br />
                  <p>
                    Beyond business, DMT Group remains deeply committed to social responsibility through Shardajeet Foundation, which actively works towards education, healthcare, women empowerment, community development, and social welfare initiatives.
                  </p>
                  <br />
                  Driven by innovation, ethical business practices, and a visionary approach since 2015, DMT Group continues to expand its footprint across India by building scalable, future-ready, and impactful solutions. The group remains dedicated to empowering communities, fostering entrepreneurship, strengthening business ecosystems, and contributing meaningfully towards India’s digital and economic growth journey.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
        <AboutSection />
      <section id="features">
        <div className="container">
          <div className="row  feature-item mt-4 mb-0 pt-4">
            <div className="col-lg-6 wow fadeInUp order-1 order-lg-2">
              <img src={featuresSvg} alt="Features" className="img-fluid" />
            </div>

            <div className="col-lg-6 wow fadeInUp pt-4 pt-lg-0 order-2 order-lg-1">
              <h4>We value our Business relations.</h4>
              <p className="paraSize">
                <b className="dmt-D">D</b>
                <b className="dmt-M">M</b>
                <b className="dmt-T">T</b> is an organization where people are
                nurtured through continuous learning and skill improvement, are
                respected, heard and encouraged to do their best. We believe
                that a company is made by its employees. We value our
                relationship with our Suppliers and trade partner. People are
                nurtured here with gradual learning and developing their skills.
                We provide individuals opportunity to showcase their talent and
                grow. Employee satisfaction is highly considered in DMT.
              </p>
              <p className="paraSize">
                <b className="dmt-D">D</b>
                <b className="dmt-M">M</b>
                <b className="dmt-T">T</b> actively work to provide an elaborate
                and accessible ecosystem to have a wide representation across
                India. We help our partners in the marketplace, gaining them
                exposure, growing networks and ultimately increasing their
                revenue. We strive to give our partners a professional and
                personalized service that truly understands their needs and
                expectations, whether it is about establishing new commercial
                relationships and coordinate sales and marketing activities with
                the trade at large.
              </p>
            </div>
          </div>
        </div>
      </section>

      <BusinessModel />

      <section id="testimonials" className="wow fadeInUp">
        <div className="container">
          <div className="section-header">
            <h3>Testimonials</h3>
          </div>
          <div className="row justify-content-center mb-5">
            <div className="col-12">
              <OwlCarousel
                className="testimonials-carousel owl-theme"
                {...options}
              >
                <div class="testimonial-item">
                  <img
                    src={require("../../static/img/testimonials/user1.png")}
                    alt=""
                    class="testimonial-img"
                  />
                  <h3>Dhirendra Modi</h3>
                  <h4>Distributor</h4>
                  <p>
                    It has been a pleasure working with <b class="dmt-D">D</b>
                    <b class="dmt-M">M</b>
                    <b class="dmt-T">T</b>. I have had very positive feedback on
                    the system which we have built together, for which I would
                    like to send you once more my compliments. Thank you for
                    your outstanding support throughout the event.
                  </p>
                </div>
                <div class="testimonial-item">
                  <img
                    src={require("../../static/img/testimonials/user2.png")}
                    alt=""
                    class="testimonial-img"
                  />
                  <h3>Ashok Sharma</h3>
                  <h4>Super Partner</h4>
                  <p>
                    DMT Tech Pvt Ltd is our invaluable partner. Their team has
                    hands-on as well as planning, supporting, architectural and
                    quality assurance experience with service oriented attitude.
                    We've found a true partner that is able to hold our hand and
                    work with us to implement our visions and strategies.
                  </p>
                </div>

                <div class="testimonial-item">
                  <img
                    src={require("../../static/img/testimonials/user3.png")}
                    alt=""
                    class="testimonial-img"
                  />
                  <h3>Divya Sachdeva</h3>
                  <h4>Distributor</h4>
                  <p>
                    Professional recommended and great experience, DMT is a
                    great utility service provider. They have shown consistency
                    and high integrity over the course of our relationship. I am
                    very impressed with their commitment and outstanding
                    services.
                  </p>
                </div>

                <div class="testimonial-item">
                  <img
                    src={require("../../static/img/testimonials/user4.png")}
                    alt=""
                    class="testimonial-img"
                  />
                  <h3>Nitish Kashyap</h3>
                  <h4>Super Partner</h4>
                  <p>
                    DMT is our invaluable partner. Their team has hands-on as
                    well as planning, supporting, architectural and quality
                    assurance experience with service oriented attitude. We've
                    found a true partner that is able to hold our hand and work
                    with us to implement our visions and strategies.
                  </p>
                </div>
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>

      {/* <section id="call-to-action" class="wow fadeInUp">
        <div class="row m-0">
          <div className="col-10 mx-auto">
            <div className="row">
              <div class="col-lg-9 mx-auto text-center text-lg-left">
                <h3 class="cta-title">Call To Action</h3>
                <p class="cta-text">
                  Whether you have a question, feedback or anything else,
                  <br />
                  Our team is ready to answer all your calls
                </p>
              </div>
              <div class="col-lg-3 cta-btn-container text-center">
                <a class="cta-btn align-middle" href="tel:0120-4151488">
                  Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="why-us" class="wow fadeIn ">
        <div class="container">
          <div class="row counters">
            <div
              class="col-lg-3 col-6 text-center wow fadeInRight"
              data-wow-delay="0.0s"
            >
              <span data-toggle="counter-up">50+</span>
              <p>Products & Services</p>
            </div>

            <div
              class="col-lg-3 col-6 text-center wow fadeInRight"
              data-wow-delay="0.1s"
            >
              <span data-toggle="counter-up">500+</span>
              <p>Associated Distributors</p>
            </div>

            <div
              class="col-lg-3 col-6 text-center wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <span data-toggle="counter-up">20K</span>
              <p>Active Retailers</p>
            </div>

            <div
              class="col-lg-3 col-6 text-center wow fadeInRight "
              data-wow-delay="0.3s"
            >
              <span data-toggle="counter-up">150K</span>
              <p>Transactions per Day</p>
            </div>
          </div>
        </div>
      </section> */}
      <ContactStats/>
    </>
  );
};

export default About;
